import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import EventEmitter from 'react-native-eventemitter';
import { ScheduleProvider } from '../context/ScheduleContext';
import GanttContainer from './GanttContainer';
import GanttToolbar from '../../../views/ganttContainer';
import Calendars from '../../ganttContainer/calendar';
import { killStorage } from '../../../assets/js/gantt_storage';
import { cleanupDropdownManager } from '../../../components/Schedule/components/dropdownHTML/utils';

// Componente interno que maneja el loading del contexto
const GanttScheduleContent = memo(() => (
  <>
    <GanttContainer />
  </>
));
GanttScheduleContent.displayName = 'GanttScheduleContent';
// Componente wrapper para mostrar GanttContainer y ScheduleView en la misma ruta
const ScheduleViewInner = (props) => {
  const match = useRouteMatch();

  useEffect(() => {
    EventEmitter.on('changeMainRoute', callback);
  }, []);

  useEffect(
    () => () => {
      if (window.to_use_react_gantt) {
        window.to_use_react_gantt.disableColorsWBS &&
          window.to_use_react_gantt.disableColorsWBS();
        killStorage();
        cleanupDropdownManager();
      }
    },
    []
  );

  const callback = (data) => {
    data.route(props.history);
  };

  return (
    <ScheduleProvider>
      <>
        <GanttToolbar />

        <span className="gantt-schedule-container">
          <Switch>
            <Route path={`${match.path}/calendars`}>
              <Calendars />
            </Route>
            <Route path={[`${match.path}/ganttchart`, `${match.path}`]}>
              <GanttScheduleContent />
            </Route>
          </Switch>
        </span>
      </>
    </ScheduleProvider>
  );
};

ScheduleViewInner.propTypes = {
  history: PropTypes.object
};

const ScheduleView = memo(ScheduleViewInner);

export default ScheduleView;
